module.exports = flarum.core.compat['utils/formatNumber'];